import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as DOCUMENT_NAME from '../../constants/documentNames';
import * as SIGNERS from '../../constants/signers';

const firebaseRef = firebase.database();

export default async function getContractStatus(parameter, callback) {
	let leadId = parameter.leadId;
	let salesAgentId = parameter.salesAgentId;

	leadId &&
		(await firebaseRef
			.ref(
				'/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId
			)
			.on('value', (snapshot) => {
				const documentInformationObj =
					snapshot.val()?.documentInformation;

				let latestStatus = {
					color: 'var(--text-high-emphasis)',
				};
				// Buyer - Client(DB name)
				// Admin - Admin(DB name)
				// Builder - Builder(DB name)
				// Firm Deal - Firm(DB name)
				// Cancelled - Cancelled(DB name)

				// 1. Get contract status
				let constractStatusObj = documentInformationObj?.contractStatus;

				let documentStatus = documentInformationObj?.documentStatus;

				switch (constractStatusObj) {
					case 'Client':
					case 'Buyer':
					case 'Second Purchaser': {
						latestStatus = {
							name: 'Buyer',
							backgroundColor: 'var(--buyer)',
							color: 'var(--white)',
						};
						break;
					}
					case 'Admin': {
						latestStatus['name'] = 'Admin';
						latestStatus['backgroundColor'] = 'var(--lots)';
						break;
					}
					case 'Builder': {
						latestStatus['name'] = 'Builder';
						latestStatus['backgroundColor'] = 'var(--builder)';
						latestStatus['color'] = 'var(--white)';
						break;
					}
					case 'Firm': {
						latestStatus['name'] = 'Firm Deal';
						latestStatus['backgroundColor'] = 'var(--firm)';
						latestStatus['color'] = 'var(--white)';
						break;
					}
					case 'Cancelled': {
						if (documentStatus === 'cancelled') {
							latestStatus['name'] = 'Cancelled';
							latestStatus['backgroundColor'] = 'var(--error)';
							latestStatus['color'] = 'var(--white)';
						} else {
							latestStatus['name'] = 'Incomplete';
							latestStatus['backgroundColor'] =
								'var(--text-low-emphasis)';
						}
						break;
					}
					case 'Cooling Period': {
						latestStatus['name'] = 'Cooling Period';
						latestStatus['backgroundColor'] = 'var(--cooling)';
						latestStatus['color'] = 'var(--white)';
						break;
					}
					default: {
						latestStatus['name'] = 'Incomplete';
						latestStatus['backgroundColor'] =
							'var(--text-low-emphasis)';
					}
				}

				// 2. Get extra info (salesAgentId, leadId, timestamp )
				latestStatus['leadId'] = leadId;
				if (salesAgentId) latestStatus['salesAgentId'] = salesAgentId;

				if (documentInformationObj) {
					let signatureRequestsObj =
						documentInformationObj?.['signatureRequests'];
					let signatureRequestsObjKeys =
						signatureRequestsObj &&
						Object.keys(signatureRequestsObj);
					let timestamp =
						signatureRequestsObj?.[signatureRequestsObjKeys[0]]?.[
							'timestamp'
						];

					if (timestamp) latestStatus['timestamp'] = timestamp;
				}

				callback(latestStatus);
			}));
}
